import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-unsync-vehicle-dialog',
  templateUrl: './unsync-vehicle-dialog.component.html',
  styleUrls: ['./unsync-vehicle-dialog.component.scss'],
})
export class UnsyncVehicleDialogComponent implements OnInit {
  vehicleId: string = '';
  isProcessing: boolean = false;
  isLoading: boolean = false;
  carfax: any = {};
  motor: any = {};
  vehicle: any = {};
  isConfirmMode: boolean = false;

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    public helperService: HelperService,
    private httpService: HTTPService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.vehicleId = this.dynamicDialogConfig.data.vehicleId;
    this.isConfirmMode = this.dynamicDialogConfig.data.isConfirmMode;
    this.getUnSyncVehicle();
  }

  getUnSyncVehicle() {
    this.isLoading = true;
    this.httpService.getUnSyncResults(this.vehicleId).then(
      ({ motor, carfax, vehicle }) => {
        this.vehicle = vehicle;

        if (motor && motor.Vehicles && motor.Vehicles[0]) {
          const { Year = '', MakeName = '', ModelName = '', SubModelName = '', EngineDescription = '' } = motor.Vehicles[0];
          this.motor = {
            ...motor.Vehicles[0],
            SearchType: motor.SearchType === 'VIN' ? 'vin' : 'ymm',
          };
          this.motor.name = this.helperService.trimString(`${Year} ${MakeName} ${ModelName} ${SubModelName} ${EngineDescription}`);
        }

        if (carfax && carfax[0]) {
          const { EngineDescription = '' } = carfax[0];
          const { Year = '', MakeName = '', ModelName = '', SubModelName = '' } = this.motor;

          this.carfax = {
            ...carfax[0],
            Year,
            MakeName,
            ModelName,
            SubModelName,
            SearchType: 'carfax',
          };
          this.carfax.name = this.helperService.trimString(`${Year} ${MakeName} ${ModelName} ${SubModelName} ${EngineDescription}`);
        }

        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  setVehicleData(vehicle: any, type: string = '') {
    const data: any = {};

    data.year = vehicle.Year;
    data.make = vehicle.MakeName;
    data.model = `${vehicle.ModelName} ${vehicle.SubModelName || ''}`;
    data.engine = vehicle.EngineDescription;
    data.name = `${vehicle.Year} ${vehicle.MakeName} ${vehicle.ModelName} ${vehicle.SubModelName}`;

    data.connectedVia = '';

    if (vehicle.licensePlateNo) {
      data.connectedVia = 'license';
      data.licensePlateNo = vehicle.licensePlateNo.toUpperCase();
    }

    if (data.VIN) {
      if (!data.connectedVia) {
        data.connectedVia = 'vin';
      }

      data.VIN = vehicle.VIN;
    }

    return data;
  }

  handleSaveOption(selectedOption: string) {
    let data: any = {};

    if (selectedOption === 'carfax') {
      data = this.setVehicleData(
        {
          ...this.carfax,
          Year: this.motor.Year,
          MakeName: this.motor.MakeName,
          ModelName: this.motor.ModelName,
          SubModelName: this.motor.SubModelName,
        },
        'carfax'
      );
      data.isMotorConnected = false;
      data.isCarfaxConnected = true;
      data.apiResponse = {};
    } else {
      data = this.setVehicleData(this.motor, 'motor');
      data.isMotorConnected = true;
      data.isCarfaxConnected = true;
      data.apiResponse = this.motor;
    }

    data._id = this.vehicleId;
    data.customerId = this.vehicle.customerId;
    data.forceUpdate = true;

    this.httpService.updateVehicle(data).then(
      (vehicle) => {
        if (vehicle.vehicle) {
          this.dataService.sendData(
            this.dataService.typeSidebar('close', null, null, {
              isSuccess: true,
              vehicle: { ...vehicle.vehicle },
              type: 'ro-vehicle',
            })
          );
        }
        this.dynamicDialogRef.close({ isSuccess: true, data });
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleClose() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }
}
